import { FormattedMessage } from 'react-intl';
import React from 'react';
import {
  Accordion,
} from '../../canvasComponents/index';
// messages
import messages from './messages';
// scss
import '../../css/domain/Dashboard/Dashboard.scss';

export default function FAQs() {
  return (
    <div className="faqs-divider faqs-text">
      <Accordion>
        <span className="faqs-row">
          <Accordion.Item>
            <Accordion.Toggle>
              <span className="faqs-title">
                <FormattedMessage {...messages.faqsQuestion1} />
              </span>
            </Accordion.Toggle>
            <Accordion.Content>
              <FormattedMessage {...messages.faqsQuestion1Content1} />
              <br />
              <FormattedMessage {...messages.faqsQuestion1Content2} />
              <br />
              <FormattedMessage {...messages.faqsQuestion1Content3} />
              <br />
              <ul className="faq-list">
                <li><FormattedMessage {...messages.faqsQuestion1Content4} /></li>
                <li><FormattedMessage {...messages.faqsQuestion1Content5} /></li>
                <li><FormattedMessage {...messages.faqsQuestion1Content6} /></li>
                <li><FormattedMessage {...messages.faqsQuestion1Content7} /></li>
                <li><FormattedMessage {...messages.faqsQuestion1Content8} /></li>
                <li><FormattedMessage {...messages.faqsQuestion1Content9} /></li>
                <li><FormattedMessage {...messages.faqsQuestion1Content10} /></li>
                <li><FormattedMessage {...messages.faqsQuestion1Content11} /></li>
              </ul>
            </Accordion.Content>
          </Accordion.Item>
        </span>
        <span className="faqs-row">
          <Accordion.Item>
            <Accordion.Toggle>
              <span className="faqs-title">
                <FormattedMessage {...messages.faqsQuestion2} />
              </span>
            </Accordion.Toggle>
            <Accordion.Content>
              <FormattedMessage {...messages.faqsQuestion2Content1} />
              <br />
              <FormattedMessage {...messages.faqsQuestion2Content2} />
              <br />
              <span className="faqs-text-bolded"><FormattedMessage {...messages.faqsQuestion2Content3} /></span>
              <span className="text-space"><FormattedMessage {...messages.faqsQuestion2Content4} /></span>
            </Accordion.Content>
          </Accordion.Item>
        </span>
        <span className="faqs-row">
          <Accordion.Item>
            <Accordion.Toggle>
              <span className="faqs-title">
                <FormattedMessage {...messages.faqsQuestion3} />
              </span>
            </Accordion.Toggle>
            <Accordion.Content>
              <FormattedMessage {...messages.faqsQuestion3Content1} />
              <br />
              <FormattedMessage {...messages.faqsQuestion3Content2} />
              <br />
              <FormattedMessage {...messages.faqsQuestion3Content3} />
            </Accordion.Content>
          </Accordion.Item>
        </span>
        <span className="faqs-row">
          <Accordion.Item>
            <Accordion.Toggle>
              <span className="faqs-title">
                <FormattedMessage {...messages.faqsQuestion4} />
              </span>
            </Accordion.Toggle>
            <Accordion.Content>
              <FormattedMessage {...messages.faqsQuestion4Content1} />
              <br />
              <span className="faqs-text-bolded"><FormattedMessage {...messages.faqsQuestion4Content2} /></span>
              <FormattedMessage {...messages.faqsQuestion4Content3} />
              <ul className="faq-list">
                <li><FormattedMessage {...messages.faqsQuestion4Content4} /></li>
                <li><FormattedMessage {...messages.faqsQuestion4Content5} /></li>
                <li><FormattedMessage {...messages.faqsQuestion4Content6} /></li>
              </ul>
              <FormattedMessage {...messages.faqsQuestion4Content7} />
              <br />
              <span className="faqs-text-bolded"><FormattedMessage {...messages.faqsQuestion4Content8} /></span>
              <br />
              <FormattedMessage {...messages.faqsQuestion4Content9} />
              <br />
              <span className="faqs-text-bolded"><FormattedMessage {...messages.faqsQuestion4Content10} /></span>
              <br />
              <FormattedMessage {...messages.faqsQuestion4Content11} />
              <br />
              <span className="faqs-text-bolded"><FormattedMessage {...messages.faqsQuestion4Content12} /></span>
              <br />
              <FormattedMessage {...messages.faqsQuestion4Content13} />
              <br />
              <span className="faqs-text-bolded"><FormattedMessage {...messages.faqsQuestion4Content14} /></span>
              <FormattedMessage {...messages.faqsQuestion4Content15} />
              <br />
              <span className="faqs-text-bolded"><FormattedMessage {...messages.faqsQuestion4Content16} /></span>
              <br />
              <FormattedMessage {...messages.faqsQuestion4Content17} />
              <br />
              <span className="faqs-text-bolded"><FormattedMessage {...messages.faqsQuestion4Content18} /></span>
              <br />
              <span className="faqs-text-bolded"><FormattedMessage {...messages.faqsQuestion4Content19} /></span>
              <br />
              <FormattedMessage {...messages.faqsQuestion4Content20} />
              <br />
              <span className="faqs-text-bolded"><FormattedMessage {...messages.faqsQuestion4Content21} /></span>
              <FormattedMessage {...messages.faqsQuestion4Content28} />
              <br />
              <span className="faqs-text-bolded"><FormattedMessage {...messages.faqsQuestion4Content22} /></span>
              <br />
              <FormattedMessage {...messages.faqsQuestion4Content23} />
              <br />
              <span className="faqs-text-bolded"><FormattedMessage {...messages.faqsQuestion4Content24} /></span>
              <br />
              <FormattedMessage {...messages.faqsQuestion4Content25} />
              <br />
              <span className="faqs-text-bolded"><FormattedMessage {...messages.faqsQuestion4Content26} /></span>
              <br />
              <FormattedMessage {...messages.faqsQuestion4Content27} />
              <br />
              <FormattedMessage {...messages.faqsQuestion4Content29} />
            </Accordion.Content>
          </Accordion.Item>
        </span>
      </Accordion>
    </div>
  );
}
